module.exports = __webpack_public_path__ + "9488d02b/img/send-icon.3cfb6275.svg";